import { type FC } from "react";

import lensStudioLogoSvg from "@app-assets/svg/lens-studio-logo.svg";

import { PageContent } from "../../layout/components";
import { Flexbox } from "../../shared/components";

import { TextContent, TextHeader, TextSubContent, iconStyle, pageContent } from "./lensStudio.styles";

export const LensStudioRedirectPage: FC = () => {
    return (
        <PageContent>
            <Flexbox flexDirection="column" className={pageContent}>
                <img alt="Lens Studio Logo" src={lensStudioLogoSvg} style={iconStyle} />
                <TextHeader>Organization created!</TextHeader>
                <TextContent>Now you can return to Lens Studio</TextContent>
                <TextSubContent>Please refresh your Asset Browser</TextSubContent>
            </Flexbox>
        </PageContent>
    );
};
